/* Preço flutuante em cima da foto do produto (celular) — aparece nos prints.
   Copia o preço da variação selecionada e acompanha a troca de cor/tamanho. */
(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  function iniciar() {
    var galeria = document.querySelector('.product-information media-gallery, media-gallery');
    var preco = document.querySelector('.product-details product-price, product-price');
    if (!galeria || !preco || galeria.querySelector('.lb-preco-foto')) return;
    var selo = document.createElement('div');
    selo.className = 'lb-preco-foto';
    selo.setAttribute('aria-hidden', 'true');
    galeria.appendChild(selo);
    var ultimo = '';
    function atualizar() {
      var atual = preco.querySelector('.price');
      var de = preco.querySelector('.compare-at-price');
      var txt = atual ? atual.textContent.trim() : '';
      var txtDe = de ? de.textContent.trim() : '';
      var chave = txt + '|' + txtDe;
      if (chave === ultimo) return;
      ultimo = chave;
      selo.innerHTML = (txtDe && txtDe !== txt ? '<s>' + txtDe + '</s>' : '') + '<strong>' + txt + '</strong>';
      selo.hidden = !txt;
    }
    atualizar();
    new MutationObserver(atualizar).observe(preco, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
